// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
import 'assets/custom-theme/index.css'; // 换肤版本element-ui css
import './styles/index.scss';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条 样式
import 'normalize.css/normalize.css';// normalize.css 样式格式化
import 'assets/iconfont/iconfont'; // iconfont 具体图标见https://github.com/PanJiaChen/vue-element-admin/wiki
import * as filters from './filters'; // 全局vue filter
import Multiselect from 'vue-multiselect';// 使用的一个多选框组件，element-ui的select不能满足所有需求
import 'vue-multiselect/dist/vue-multiselect.min.css';// 多选框组件css
import Sticky from 'components/Sticky'; // 粘性header组件
import IconSvg from 'components/Icon-svg';// svg 组件
import vueWaves from './directive/waves';// 水波纹指令
import errLog from 'store/errLog';// error log组件
import './mock/index.js';  // 该项目所有请求使用mockjs模拟
// import caiNiaoPrinter from 'store/modules/caiNiaoPrint.js';  // caiNiaoPrinter.js
import axios from 'axios';
import { ZTree } from './components/index.js';
import './utils/Ice.min.js';
import cwms from './utils/Printer.js';
import 'font-awesome/css/font-awesome.css'
import echarts from 'echarts'
Vue.prototype.$iceProxy = cwms;
Vue.prototype.$echarts = echarts
// Vue.prototype.$caiNiaoProxy = caiNiaoPrinter;

import * as socketApi from 'store/modules/caiNiaoPrint.js'
Vue.prototype.socketApi = socketApi

import * as hrSocketApi from 'store/modules/hrPrint.js'
Vue.prototype.hrSocketApi = hrSocketApi

// register globally
Vue.component('multiselect', Multiselect);
Vue.component('Sticky', Sticky);
Vue.component('icon-svg', IconSvg)
Vue.use(ElementUI);
Vue.use(vueWaves);
Vue.use(ZTree)

Vue.directive('elUpdate', {
  update(el, binding) {
    if (binding.value.indexOf(binding.arg) === -1) {
      binding.value.push(binding.arg);
    }
  }
});

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});


const API_URL = 'API_URL'
const CON_URL = 'CON_URL'
const WEBSOCKET_URL = 'WEBSOCKET_URL'
const SHOW_TIP_MESSAGE = SHOW_TIP_MESSAGE
store.commit('jumpCon', CON_URL)
// axios 配置
axios.defaults.timeout = 30000
axios.defaults.baseURL = API_URL
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// http request 拦截器
axios.interceptors.request.use(
    config => {
      if (store.getters.authToken) {
        config.headers.Authorization = `bearer ${store.getters.authToken}`
      }
      return config
    },
    err => Promise.reject(err))

// http response 拦截器
axios.interceptors.response.use(
    response => response,
    error => {
      // 超时
      if (error.code === 'ECONNABORTED' || !error.response) {
        appVue.$notify.error({
          title: '错误',
          message: '网络暂时未能连通'
        })
      } else if (error.response) {
        switch (error.response.status) {
          case 401:
            appVue.$notify.warning({
              title: '警告',
              message: '您的签名已失效请重新登录'
            })
            // 401 清除token信息并跳转到登录页面
            store.commit('authToken', null)
            if (window.localStorage) {
              window.localStorage.removeItem('authToken')
            }
            router.push('/login')
            break
          case 500:
            appVue.$notify.error({
              title: '错误',
              message: '未知异常'
            })
            break
        }
      }
      return Promise.reject(error)
    })

// Vue.http.options.emulateHTTP = true
// Vue.http.options.emulateJSON = true
Vue.prototype.axios = axios
Vue.prototype.Loading = ElementUI.Loading
Vue.prototype.context = {
  showTipMessage: SHOW_TIP_MESSAGE
}

const whiteList = ['/login']
router.beforeEach((to, from, next) => {
  NProgress.start() // 开启Progress
  let authToken = store.getters.authToken
  if (authToken == null && window.localStorage) {
    authToken = window.localStorage.getItem('authToken')
    store.commit('authToken', authToken)
    store.commit('account', {
      accountId: window.localStorage.getItem('accountId'),
      userName: window.localStorage.getItem('userName'),
      language: window.localStorage.getItem('language')
    })
    // authToken = '111'
    // window.localStorage.setItem('authToken', authToken)
  }
  if (authToken != null) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // const language = window.localStorage ? window.localStorage.getItem('language') : null
      // if (language !== null) {
      //   global.$fn.i18nConfig.lang = language
      //   global.$fn.veeConfig.setLocale(language)
      // }
      if (store.getters.functions.length === 0) {
        axios.get('api/user/functions').then(resp => {
          if (resp.data.code === 0) {
            const functions = resp.data.data
            if (functions.length === 0) {
              appVue.$notify.error({
                title: '错误',
                message: '您没有权限访问，请联系管理员'
              })
              store.commit('authToken', null)
              if (window.localStorage) window.localStorage.removeItem('authToken')
            } else {
              store.commit('setFunctions', functions)
              store.dispatch('GenerateRoutes', { functions }).then(() => { // 生成可访问的路由表
                router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                store.commit('switchMenu', to.path)
                store.dispatch('initViews', to)
                next({ ...to }) // hack方法 确保addRoutes已完成
              })
            }
          }
        })
        // const functions = [20, 200000, 210000, 250000, 240000]
        // store.commit('setFunctions', functions)
        // store.dispatch('GenerateRoutes', { functions }).then(() => { // 生成可访问的路由表
        //   router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
        //   next({ ...to }) // hack方法 确保addRoutes已完成
        // })
      } else {
        store.dispatch('checkClose', to).then(isClose => {
          if (isClose) {
            if (!to.meta.count || to.meta.count === undefined) {
              to.meta.count = 1
            } else {
              to.meta.count += 1
            }
          }
        })
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

Vue.config.productionTip = false;

let websocket = null;
function initWebSocket() {
  websocket = new WebSocket(WEBSOCKET_URL);

  websocket.onopen = function() {
    console.log('连接成功');
  }

  websocket.onclose = function() {
    console.log('退出连接');
  }

  websocket.onmessage = function(event) {
    localStorage.setItem('addressData', event.data)
    console.log(event.data);
  }

  websocket.onerror = function() {
    console.log('连接出错');
  }

  window.onbeforeunload = function() {
    websocket.close();
  }
}
initWebSocket();

// 生产环境错误日志
if (process.env === 'production') {
  Vue.config.errorHandler = function(err, vm) {
    console.log(err, window.location.href);
    errLog.pushLog({
      err,
      url: window.location.href,
      vm
    })
  };
}

const appVue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js